<nts-loader [skipHeader]="false" [isVisible]="!url || actionInProgress"></nts-loader>
<nts-iframe #iframe (loading)="iframeLoading($event)" *ngIf="url" [url]="url" [allow]="true"></nts-iframe>
